export default __webpack_public_path__ + "static/media/ii.59fd2565.png";